var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.2,
    height: 17.2,
    viewBox: "0 0 15.2 17.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-2.4 -1.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_577",
    "data-name": "Ret\\xE2ngulo 577",
    width: 14,
    height: 14,
    rx: 2,
    transform: "translate(3 3.767)",
    fill: "none",
    stroke: "#848484",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_29",
    "data-name": "Linha 29",
    y2: 3,
    transform: "translate(13 1.767)",
    fill: "none",
    stroke: "#848484",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_30",
    "data-name": "Linha 30",
    y2: 3,
    transform: "translate(7 1.767)",
    fill: "none",
    stroke: "#848484",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_31",
    "data-name": "Linha 31",
    x2: 14,
    transform: "translate(3 8.767)",
    fill: "none",
    stroke: "#848484",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.aebc7b4cc9a4367f7a2fa22526ac3e07.svg";
export { ForwardRef as ReactComponent };